










































import * as service from '@/services/environmental/index';
import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component({
  name: "CarInfractionsModal",
})
export default class CarInfractionsModal extends Vue {

  @Prop({type: String, required: true})
  private analysisUuid!: string;

  @Prop({ type: Number, default: 2020 }) 
  private currentYear!: number;

  @Prop({ type: Array, default: [] }) 
  private allYears!: number[];

  @Prop({ type: Boolean, default: false }) 
  private isVisible!: boolean;
  

  private isLoading: boolean = false;
  private years = "ALL";

  @Emit("onsubmit")
  public async emitConfirmAction() {
    let res = await service.create(this.analysisUuid, this.years == 'ALL' ? this.allYears : [this.currentYear]);
    return res.find(it => it.year == this.currentYear);
  }

  @Emit("oncancel")
  public emitCancelAction() {
    return "";
  }
}
